const routes = [
  {
    path: '/informationRelease',
    name: 'informationRelease',
    component: () => import('./pages/Home'),
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'parkNotice', // 园区公告
        name: 'parkNotice',
        component: () => import('./pages/ParkNotice'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      }
    ]
  }
]

export default routes